import React from 'react'
import StepOne from '../Steps/StepOne'
import StepTwo from '../Steps/StepTwo'
import StepThree from '../Steps/StepThree'
import StepFour from '../Steps/StepFour'
import BriefForm from '@src/components/AdvertisingCampaign/Form/BriefForm'
import { Formik } from '@src/types/BriefSocial/formikProps'
import { UserData } from '@src/types'

interface Props {
  userData: UserData | null
  sendStartFillingBriefAnalytics: () => void
}

const Brief: React.FC<Props & Formik> = props => {
  return (
    <BriefForm {...props}>
      <StepOne />
      <StepTwo />
      <StepThree />
      <StepFour />
    </BriefForm>
  )
}

export default Brief
